import {Component,Inject,OnInit} from '@angular/core';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,MatLegacyDialog as MatDialog,MatLegacyDialogRef as MatDialogRef} from "@angular/material/legacy-dialog";
import {TranslateService} from "@ngx-translate/core";
import {ListView} from "@domain/common/list-view";
import {Result} from "@domain/common/http/result";
import {MontantListItemComponent} from "@components/admin/frais/prestations/prestation-detail/regles-gestion/montant-popin/montant-list-item.component";
import {Montant} from "@domain/prestation/montant";
import {MontantDetailComponent} from "@components/admin/frais/prestations/prestation-detail/regles-gestion/montant-popin/montant-detail.component";
import * as moment from "moment";

/**
 * Composant d'affichage de la popin de montant
 *
 * @author Lionel Gimenez
 * @date 06/01/2026
 */
@Component({
    host: {'data-test-id': 'montant-popin'},
    selector: 'montant-popin',
    templateUrl: './montant-popin.component.html',
    styles: [
        '::ng-deep .mat-dialog-without-margin .mat-dialog-container { padding: 0 }',
        '::ng-deep .mat-dialog-without-margin .mat-card { margin-bottom: 0 }'
    ]
})
export class MontantPopinComponent implements OnInit {
    /** Liste des montants */
    listeMontant: ListView<Montant,MontantListItemComponent>;

    /**
     * Constructeur
     */
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            idPrestation: number,
            devise: string;
        },
        private translateService: TranslateService,
        private matDialogRef: MatDialogRef<MontantPopinComponent>,
        private matDialog: MatDialog
    ) {
    }

    /**
     * Initialisation du composant
     */
    ngOnInit(): void {
        //Initialisation de la liste
        this.listeMontant = new ListView<Montant,MontantListItemComponent>({
            uri: `/controller/AdminPrestation/listeMontant/${this.data.idPrestation}`,
            title: this.translateService.instant(`admin.frais.prestations.detail.reglesGestion.remboursement.montant.popin.historique`),
            component: MontantListItemComponent,
            isSimple: true,
            maxScrollableHeight: '70vh',
            mapResult: (result: Result) => result?.data?.listeMontant as Montant[],
            extraOptions: {
                devise: this.data.devise
            },
            listeActions: [
                {
                    icon: 'add',
                    onPress: () => this.createMontant()
                },{
                    icon: 'close',
                    onPress: () => this.close()
                }
            ]
        });
    }

    /**
     * Création d'un montant
     */
    createMontant(): void {
        //Initialisation du montant
        const montant = new Montant();

        //Valeurs par défaut
        montant.idPrestation = this.data.idPrestation;
        montant.dateApplication = moment().toDate();

        //Ouverture de la popin de création
        this.matDialog.open(MontantDetailComponent,{
            data: {
                montant: montant,
                isCreation: true
            },
            width: '65%',
        }).afterClosed().subscribe((refresh: boolean) => {
            if (refresh) {
                //Rafraîchissement de la liste
                this.listeMontant.refresh();
            }
        })
    }

    //Fermeture du dialog
    close(): void {
        if (this.listeMontant.data.listeResultats.length == 0) {
            //Si la liste est vide, on ferme le dialog
            this.matDialogRef.close();
        } else {
            //On récupère le premier montant qui est plus récent
            this.matDialogRef.close(this.listeMontant.data.listeResultats[0]);
        }
    }
}